import React, { useEffect } from "react";
import { StateForm } from "./Forms/StateForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneStateQuery,
  useUpdateStateMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditState = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: stateResponse,
    isLoading,
    isFetching,
  } = useGetOneStateQuery({ id });
  const state = stateResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateState, isPending } = useUpdateStateMutation(setError);

  const onSubmit = (data) => {
    updateState(data);
  };

  useEffect(() => {
    if (state) {
      reset(state);
    }
  }, [state, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_STATE")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <StateForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_STATE")}
                  </>
                ) : (
                  t("UPDATE_STATE")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

